import React, { useState } from "react";
import Swal from "sweetalert2";
import { apiUrl } from "../../../utils/apiBase";

function FeedbackForm() {
    const [formData, setFormData] = useState({
        full_name: "",
        phone_number: "",
        place: "",
        willing_to_contribute: "",
    });

    const [status, setStatus] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleCheckboxChange = (e) => {
        const { id } = e.target;
        if (id === "willingYes") {
            setFormData((prev) => ({
                ...prev,
                willing_to_contribute: "Yes",
            }));
        } else if (id === "willingNo") {
            setFormData((prev) => ({
                ...prev,
                willing_to_contribute: "No",
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.willing_to_contribute) {
            setStatus("Please select if you are willing to contribute or not.");
            return;
        }

        setIsSubmitting(true);
        setStatus("");

        try {
            const response = await fetch(apiUrl('3-day-natural-healt-retreat-survey-form/'), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
               Swal.fire({
    icon: "success",
    title: "Thank you!",
    text: "We’ve received your form. We’ll contact you with more details soon.",
    confirmButtonColor: "#3085d6",
}).then(() => {
    window.location.href = "/";
});


                // Reset form
                setFormData({
                    full_name: "",
                    phone_number: "",
                    place: "",
                    willing_to_contribute: "",
                });
            } else {
                setStatus("Failed to submit. Please try again.");
            }
        } catch (error) {
            setStatus("An error occurred. Please try again.");
        }

        setIsSubmitting(false);
    };

    return (
        <>
            <section className="contact-section">
                <div className="container">
                    <div className="contact">
                        <div className="row justify-content-center">
                            {/* Retreat Info Box */}

                            <div className="con-text col-md-11">



                                <h1 className="mb-5">
                                    <strong>A 3-Days Natural Health Retreat</strong>
                                </h1>
                                <div className="retreat-info-box bg-white p-4 rounded-3 shadow-sm mb-4">
                                    <h4 className="fw-bold mb-3 text-center">🌿 You're Invited! / आपका स्वागत है!</h4>

                                    <p className="text-center mb-4">
                                        <strong>Vardhman Prakritik Chikitsa Sansthan, Bhind</strong> and <strong>Anuyog</strong> present a unique 3-day residential retreat. <br />
                                        <strong>वर्धमान प्राकृतिक चिकित्सा संस्थान, भिंड</strong> और <strong>अनुयोग</strong> प्रस्तुत करते हैं एक विशेष 3-दिवसीय आवासीय रिट्रीट।
                                    </p>

                                    <div className="row text-start mb-3">
                                        <div className="col-md-6">
                                            <ul className="mb-2">
                                                <li>🧘‍♂️ Natural healing therapies / प्राकृतिक उपचार पद्धतियाँ</li>
                                                <li>🧘 Yoga & meditation amidst serene nature / शांत वातावरण में योग</li>
                                                <li>🎶 Soulful bhajans & devotional energy / भक्ति से भरे भजन और दिव्यता</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <ul className="mb-2">
                                                <li>🧑‍🏫 Sessions with experts / विशेषज्ञों के साथ संवाद</li>
                                                <li>🤝 Meet like-minded people / समान सोच वालों से जुड़ें</li>
                                                <li>🥗 Satvic meals by naturopathy experts / प्राकृतिक  सात्विक भोजन</li>
                                                
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="row gy-2 text-start">
                                         <div className="col-12 col-md-6">💰 <strong>Contribution:</strong> ₹9,000 – ₹10,000</div>
                                        
                                        <div className="col-12 col-md-6">🗓️ <strong>Duration:</strong> 3 Days</div>
                                        
                                       <div className="col-12 col-md-6">📍 <strong>Location:</strong> Near Bangalore (e.g.Shravanbelagola)</div>
                                        <div className="col-12 col-md-6">📅 <strong>Date (Tentative):</strong> Between 15th Sept – 15th Oct</div>
                                        <div className="col-12 col-md-6">🛏️ <strong>Stay:</strong> Simple, non-AC shared accommodation — natural, serene setting</div>
                                        <div className="col-12 col-md-6">🎓 <strong>NDDY Students:</strong> 1-month practical exemption / 1 माह की प्रैक्टिकल छूट</div>
                                    </div>

                                    <p className="fw-semibold text-center mt-4">
                                        👇 If you're interested, please fill out the form below. <br />
                                        अगर आप इसमें रुचि रखते हैं, तो कृपया नीचे दिया गया फॉर्म भरें।
                                    </p>
                                </div>


                                {/* Feedback Form */}
                                <form className="contact-form" onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-sm-6 d-flex align-items-start flex-column">
                                            <label htmlFor="full_name">Enter Your Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="full_name"
                                                name="full_name"
                                                placeholder="e.g. John Doe"
                                                value={formData.full_name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>

                                        <div className="col-sm-6 d-flex align-items-start flex-column">
                                            <label htmlFor="phone_number">Enter Your Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="phone_number"
                                                name="phone_number"
                                                placeholder="e.g. +91 XXXXX XXXXX"
                                                value={formData.phone_number}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>

                                        <div className="col-md-12 d-flex align-items-start flex-column">
                                            <label htmlFor="place">Enter Your Address</label>
                                            <textarea
                                                className="form-control"
                                                id="place"
                                                name="place"
                                                rows="4"
                                                placeholder="Your Address"
                                                value={formData.place}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="col-md-12 mt-3 text-start">
                                            <label className="d-block mb-2">
                                                <strong>Are you willing to contribute to and attend this retreat?</strong>
                                            </label>
                                            <div className="d-flex align-items-center">
                                                <div className="form-check me-4">
                                                    <input
                                                        type="checkbox"
                                                        name="willing_to_contribute"
                                                        id="willingYes"
                                                        checked={formData.willing_to_contribute === "Yes"}
                                                        onChange={handleCheckboxChange}
                                                        style={{ width: "20px", height: "20px" }}
                                                    />
                                                    <label htmlFor="willingYes" className="ms-2">Yes</label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        name="willing_to_contribute"
                                                        id="willingNo"
                                                        checked={formData.willing_to_contribute === "No"}
                                                        onChange={handleCheckboxChange}
                                                        style={{ width: "20px", height: "20px" }}
                                                    />
                                                    <label htmlFor="willingNo" className="ms-2">No</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-xl-6 mx-auto mt-4">
                                            <div className="form-button text-center">
                                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                                    {isSubmitting ? "Submitting..." : "Submit Feedback"}
                                                </button>
                                            </div>
                                        </div>

                                        {status && (
                                            <div className="col-md-12 mt-3">
                                                <p className="text-center text-danger">{status}</p>
                                            </div>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default FeedbackForm;
